var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.05 16.5C18.05 21.47 14.01 25.5 9.024 25.5C7.84053 25.5016 6.66833 25.27 5.57434 24.8186C4.48035 24.3672 3.48599 23.7047 2.64804 22.8689C1.81008 22.0332 1.14494 21.0406 0.690588 19.9478C0.236237 18.8551 0.00157481 17.6835 0 16.5C0 11.528 4.04 7.50001 9.024 7.50001C10.2076 7.49817 11.3801 7.72952 12.4743 8.18084C13.5685 8.63216 14.5631 9.29462 15.4013 10.1304C16.2394 10.9661 16.9047 11.9588 17.3592 13.0517C17.8137 14.1446 18.0484 15.3164 18.05 16.5ZM27.95 16.5C27.95 21.18 25.93 24.972 23.438 24.972C20.946 24.972 18.926 21.178 18.926 16.5C18.926 11.82 20.946 8.02801 23.438 8.02801C25.93 8.02801 27.95 11.822 27.95 16.5ZM32 16.5C32 20.692 31.29 24.09 30.412 24.09C29.536 24.09 28.826 20.69 28.826 16.5C28.826 12.308 29.536 8.91001 30.414 8.91001C31.29 8.91001 32 12.308 32 16.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.af196836c67cf19bbcbd040ebaf88bdb.svg";
export { ForwardRef as ReactComponent };